import L from 'leaflet';

/**
 * How much of the map the device panel covers: the left edge on desktop, the bottom
 * on phones (see MapPage). Framing uses it so devices aren't hidden under the panel.
 */
export function panelInsets(map: L.Map): { left: number; bottom: number } {
  const size = map.getSize();
  return window.matchMedia('(min-width: 768px)').matches
    ? { left: Math.min(380, size.x / 2), bottom: 0 }
    : { left: 0, bottom: Math.round(size.y * 0.48) };
}

/** Centres `target` in the part of the map the panel doesn't cover. */
export function flyToVisible(map: L.Map, target: L.LatLng, zoom: number) {
  const { left, bottom } = panelInsets(map);
  const point = map.project(target, zoom).subtract([left / 2, -bottom / 2]);
  map.flyTo(map.unproject(point, zoom), zoom, { duration: 0.6 });
}

/** True when `target` is off screen or hidden under the panel. */
export function outsideVisible(map: L.Map, target: L.LatLng, margin = 60): boolean {
  const { left, bottom } = panelInsets(map);
  const size = map.getSize();
  const p = map.latLngToContainerPoint(target);
  return p.x < left + margin || p.x > size.x - margin || p.y < margin || p.y > size.y - bottom - margin;
}

/** Fits these points into the part of the map the panel doesn't cover. */
export function fitVisible(map: L.Map, points: L.LatLng[], maxZoom = 16): void {
  const { left, bottom } = panelInsets(map);
  map.fitBounds(L.latLngBounds(points), {
    paddingTopLeft: [left + 50, 60],
    paddingBottomRight: [60, bottom + 50],
    maxZoom,
  });
}
